import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../global/functions/apiClient";
import { getAuthHeaders } from "../global/functions/authorization";
const apiUrl = process.env.REACT_APP_API_URL;
const initialState = {
  items: [],
  status: "idle",
  error: null,
  success: null,
  loading: false,
};

export const getCurrencys = createAsyncThunk(
  "currency/getCurrencys",
  async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/currency`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);
export const addCurrency = createAsyncThunk(
  "currency/addCurrency",
  async (body) => {
    try {
      const response = await axios.post(
        `${apiUrl}/currency`,
        body,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

export const modifyCurrency = createAsyncThunk(
  "currency/modifyCurrency",
  async ({ body, currencyId }) => {
    try {
      const response = await axios.put(
        `${apiUrl}/currency/${currencyId}`,
        body,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);
export const deleteCurrency = createAsyncThunk(
  "currency/deleteCurrency",
  async (currencyId) => {
    try {
      const response = await axios.delete(
        `${apiUrl}/currency/${currencyId}`,
        getAuthHeaders(false)
      );
      return response?.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || err.message);
    }
  }
);

const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    updateStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getCurrencys.pending, (state, action) => {
        state.status = "loadingFetchData";
        state.loading = true;
      })
      .addCase(getCurrencys.fulfilled, (state, action) => {
        state.status = "fetchData";
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getCurrencys.rejected, (state, action) => {
        state.status = "fetchError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addCurrency.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(addCurrency.fulfilled, (state, action) => {
        state.status = "addSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(addCurrency.rejected, (state, action) => {
        state.status = "addError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteCurrency.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(deleteCurrency.fulfilled, (state, action) => {
        state.status = "deleteSuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(deleteCurrency.rejected, (state, action) => {
        state.status = "deleteError";
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(modifyCurrency.pending, (state, action) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(modifyCurrency.fulfilled, (state, action) => {
        state.status = "modifySuccess";
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(modifyCurrency.rejected, (state, action) => {
        state.status = "modifyError";
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export const { updateStatus } = currencySlice.actions;
export const selectAllCurrencys = (state) => state.currency.items;
export const getCurrencysStatus = (state) => state.currency.status;
export const getCurrencysError = (state) => state.currency.error;
export const getCurrencysSuccess = (state) => state.currency.success;
export const getCurrencysLoading = (state) => state.currency.loading;
export default currencySlice.reducer;
